import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "panningtypes"
    }}>{`PanningTypes`}</h1>
    <p>{`The display performance settings to use while scrolling.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`NO_GREEKING`}</strong>{` = 1699116368`}</p>
      <p parentName="blockquote">{`While scrolling, does not greek images or text; lowest quality display with the fastest performance.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`GREEK_IMAGES`}</strong>{` = 1699111248`}</p>
      <p parentName="blockquote">{`While scrolling, greeks newly revealed images until the mouse is released; medium quality display with medium performance speed.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`GREEK_IMAGES_AND_TEXT`}</strong>{` = 1699639120`}</p>
      <p parentName="blockquote">{`While scrolling, greeks newly revealed images and text until the mouse is released; highest quality display with the slowest performance.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      